'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ATTACHMENTS = exports.ATTACHMENTS = ['attachments'];
var TEXT = exports.TEXT = ['text'];
var RICH_TEXT = exports.RICH_TEXT = ['richText'];
var MESSAGE_STATUS = exports.MESSAGE_STATUS = ['status', 'messageStatus'];
var MESSAGE_STATUS_SOURCE = exports.MESSAGE_STATUS_SOURCE = ['status', 'source'];
var MESSAGE_STATUS_TIMESTAMP = exports.MESSAGE_STATUS_TIMESTAMP = ['status', 'timestamp'];
var TIMESTAMP = exports.TIMESTAMP = ['timestamp'];
var SENDER_TYPE = exports.SENDER_TYPE = ['sender', '@type'];
var MESSAGE_ID = exports.MESSAGE_ID = ['id'];
var HAS_MORE = exports.HAS_MORE = ['hasMore'];
var MESSAGE_DELETE_STATUS = exports.MESSAGE_DELETE_STATUS = ['messageDeletedStatus'];
var CONTENT_TYPE = exports.CONTENT_TYPE = ['contentType'];
var TYPE = exports.TYPE = ['@type'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/constants/keyPaths.js
// module id = 364
// module chunks = 2 3